(function () {
  'use strict';

  /* Shared product index (one fetch per page, shared by every lookup section) */
  var productIndex = null;
  var productIndexReady = null;
  var CACHE_KEY = 'lpl_product_index';
  var CACHE_TS_KEY = 'lpl_product_ts';
  var CACHE_TTL = 30 * 60 * 1000;

  function ensureProductIndex() {
    if (!productIndexReady) productIndexReady = loadProductIndex();
    return productIndexReady;
  }

  function loadProductIndex() {
    return new Promise(function (resolve) {
      try {
        var ts = sessionStorage.getItem(CACHE_TS_KEY);
        var cached = sessionStorage.getItem(CACHE_KEY);
        if (ts && cached && (Date.now() - parseInt(ts, 10)) < CACHE_TTL) {
          productIndex = JSON.parse(cached);
          resolve(productIndex);
          return;
        }
      } catch (e) {}

      fetchAllProducts(function (index) {
        productIndex = index;
        try {
          sessionStorage.setItem(CACHE_KEY, JSON.stringify(index));
          sessionStorage.setItem(CACHE_TS_KEY, String(Date.now()));
        } catch (e) {}
        resolve(index);
      });
    });
  }

  function fetchAllProducts(callback) {
    var index = {};
    var page = 1;

    function fetchPage() {
      fetch('/products.json?limit=250&page=' + page)
        .then(function (res) { return res.json(); })
        .then(function (data) {
          var products = data.products || [];
          products.forEach(function (p) {
            var card = {
              title: p.title,
              handle: p.handle,
              url: '/products/' + p.handle,
              image: (p.images && p.images[0]) ? p.images[0].src : '',
              price: p.variants && p.variants[0] ? p.variants[0].price : null,
              compare_at_price: p.variants && p.variants[0] ? p.variants[0].compare_at_price : null,
              available: p.variants ? p.variants.some(function (v) { return v.available; }) : false,
              body: (p.body_html || '').replace(/<[^>]*>/g, '').substring(0, 60)
            };
            if (p.variants) {
              p.variants.forEach(function (v) {
                if (v.sku) {
                  index[v.sku.replace(/\s+/g, '').toLowerCase()] = card;
                }
              });
            }
          });
          if (products.length === 250) { page++; fetchPage(); }
          else { callback(index); }
        })
        .catch(function () { callback(index); });
    }
    fetchPage();
  }

  function matchCatalogItem(index, item) {
    var itemNo = (item.ItemNo || '').replace(/\s+/g, '').toLowerCase();
    if (!itemNo) return null;
    if (index[itemNo]) return index[itemNo];
    var noDash = itemNo.replace(/-/g, '');
    if (noDash !== itemNo && index[noDash]) return index[noDash];
    return null;
  }

  function renderCard(p) {
    var price = p.price ? formatMoney(p.price) : '';
    var cmp = p.compare_at_price ? formatMoney(p.compare_at_price) : '';
    var onSale = cmp && parseFloat(p.compare_at_price) > parseFloat(p.price);

    var badge = '';
    if (!p.available) badge = '<div class="card__badge"><span class="badge badge--soldout">Udsolgt</span></div>';
    else if (onSale) badge = '<div class="card__badge"><span class="badge badge--onsale">Tilbud</span></div>';

    var priceHtml = '';
    if (price) {
      if (onSale) {
        priceHtml = '<div class="price price--on-sale"><dl><div class="price__sale">' +
          '<dd><s class="price-item price-item--regular">' + cmp + '</s></dd>' +
          '<dd><span class="price-item price-item--sale">' + price + '</span></dd>' +
          '</div></dl></div>';
      } else {
        priceHtml = '<div class="price"><dl><div class="price__regular">' +
          '<dd><span class="price-item price-item--regular">' + price + '</span></dd>' +
          '</div></dl></div>';
      }
    }

    return '<div class="card-wrapper pro-card-wrapper">' +
      '<div class="card card--product">' +
        '<a href="' + esc(p.url) + '" class="card__media media-wrapper">' +
          '<div class="image-animate media media--square">' +
            (p.image ? '<img src="' + esc(p.image) + '" alt="' + esc(p.title) + '" loading="lazy" width="533" height="533" style="object-fit:contain;">' :
            '<div style="width:100%;height:100%;background:rgb(var(--color-background));"></div>') +
          '</div>' +
        '</a>' + badge +
      '</div>' +
      '<div class="card-information"><div class="card-information__wrapper">' +
        '<a href="' + esc(p.url) + '" class="card-information__text h4">' + esc(p.title) + '</a>' +
        priceHtml +
        (p.body ? '<div class="product_short"><p>' + esc(p.body) + '</p></div>' : '') +
      '</div></div>' +
      '<div class="card-information__button">' +
        (p.available ?
          '<a href="' + esc(p.url) + '" class="button button--small">Tilføj til kurv</a>' :
          '<button class="button button--small button--soldout" disabled>Udsolgt</button>') +
      '</div>' +
    '</div>';
  }

  function formatMoney(price) {
    var num = parseFloat(price);
    if (isNaN(num)) return '';
    var parts = num.toFixed(2).split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return parts.join(',') + ' DKK';
  }

  function esc(str) {
    if (!str) return '';
    var d = document.createElement('div');
    d.appendChild(document.createTextNode(str));
    return d.innerHTML;
  }

  /* Each lookup section gets its own isolated instance, so the section can be
     duplicated in the theme editor and every copy works independently. */
  function initSection(section) {
    var PROXY_BASE = section.dataset.proxyUrl || '';
    var lookupPageUrl = section.dataset.lookupPage || '';

    var form = section.querySelector('[data-lpl-form]');
    var input = section.querySelector('[data-lpl-input]');
    var submitBtn = section.querySelector('[data-lpl-submit]');
    var vehicleInfo = section.querySelector('[data-lpl-vehicle]');
    var vehicleMake = section.querySelector('[data-lpl-vehicle-make]');
    var vehicleDetails = section.querySelector('[data-lpl-vehicle-details]');
    var errorBox = section.querySelector('[data-lpl-error]');
    var resultsHeading = section.querySelector('[data-lpl-results-heading]');
    var resultsCount = section.querySelector('[data-lpl-results-count]');
    var resultsContainer = section.querySelector('[data-lpl-results-container]');
    var categoryNav = section.querySelector('[data-lpl-category-nav]');
    var noResults = section.querySelector('[data-lpl-no-results]');

    var activeCategory = 'all';

    function onSubmit(e) {
      e.preventDefault();
      var plate = (input.value || '').trim().toUpperCase().replace(/\s+/g, '');
      if (!plate || plate.length < 2) {
        showError('Indtast venligst en gyldig nummerplade.');
        return;
      }

      if (lookupPageUrl) {
        window.location.href = lookupPageUrl + '?plate=' + encodeURIComponent(plate);
        return;
      }

      resetResults();
      setLoading(true);

      Promise.all([
        fetch(PROXY_BASE + '/api/lookup?plate=' + encodeURIComponent(plate))
          .then(function (res) {
            if (!res.ok) return res.json().then(function (d) { throw new Error(d.error || 'Opslag fejlede.'); });
            return res.json();
          }),
        ensureProductIndex()
      ])
      .then(function (results) {
        var data = results[0];
        var index = results[1];
        setLoading(false);
        if (data.vehicle) showVehicleInfo(data.vehicle);
        if (data.catalog && data.catalog.length > 0) {
          displayResults(data.catalog, index);
        } else {
          showNoResults();
        }
      })
      .catch(function (err) {
        setLoading(false);
        showError(err.message || 'Der opstod en fejl. Prøv igen senere.');
      });
    }

    function showVehicleInfo(vehicle) {
      if (!vehicleInfo) return;
      if (vehicleMake) {
        var parts = [];
        if (vehicle.Make) parts.push(vehicle.Make);
        if (vehicle.Model) parts.push(vehicle.Model);
        if (vehicle.Type) parts.push(vehicle.Type);
        vehicleMake.textContent = parts.join(' ');
      }
      if (vehicleDetails) {
        var meta = [];
        if (vehicle.FirstRegDate) {
          meta.push('<span>Årgang: <strong>' + esc(vehicle.FirstRegDate.substring(0, 4)) + '</strong></span>');
        }
        if (vehicle.Drivmiddel) {
          var fuel = { '1': 'Benzin', '2': 'Diesel', '3': 'El', '4': 'Hybrid' };
          meta.push('<span>Brændstof: <strong>' + (fuel[vehicle.Drivmiddel] || vehicle.Drivmiddel) + '</strong></span>');
        }
        if (vehicle.Licensplate) {
          meta.push('<span>Plade: <strong>' + esc(vehicle.Licensplate) + '</strong></span>');
        }
        vehicleDetails.innerHTML = meta.join('');
      }
      vehicleInfo.classList.add('is-visible');
    }

    function displayResults(catalog, index) {
      var grouped = {};
      var shopMap = {};

      catalog.forEach(function (item) {
        var match = matchCatalogItem(index, item);
        if (!match) return;
        shopMap[item.ItemNo] = match;
        var cat = item.ProductCategory || 'Andet';
        if (!grouped[cat]) grouped[cat] = [];
        grouped[cat].push(item);
      });

      var catKeys = Object.keys(grouped).sort();
      var totalMatched = Object.keys(shopMap).length;

      if (totalMatched === 0) { showNoResults(); return; }

      var html = '';
      catKeys.forEach(function (cat) {
        html += '<div class="lpl-category-group" data-lpl-group="' + esc(cat) + '">';
        html += '<h3 class="lpl-category-group__title">' + esc(cat) + '</h3>';
        html += '<ul class="product-grid grid grid--2-col grid--3-col-tablet grid--4-col-desktop" role="list">';
        grouped[cat].forEach(function (item) {
          html += '<li class="grid__item">' + renderCard(shopMap[item.ItemNo]) + '</li>';
        });
        html += '</ul></div>';
      });

      resultsContainer.innerHTML = html;
      updateResultsHeading(totalMatched);

      if (catKeys.length > 1) {
        var navHtml = '<button class="lpl-category-btn is-active" data-category="all">Alle</button>';
        catKeys.forEach(function (cat) {
          navHtml += '<button class="lpl-category-btn" data-category="' + esc(cat) + '">' +
                     esc(cat) + ' (' + grouped[cat].length + ')</button>';
        });
        categoryNav.innerHTML = navHtml;
        categoryNav.classList.add('is-visible');
        categoryNav.querySelectorAll('.lpl-category-btn').forEach(function (btn) {
          btn.addEventListener('click', function () {
            activeCategory = this.dataset.category;
            categoryNav.querySelectorAll('.lpl-category-btn').forEach(function (b) { b.classList.remove('is-active'); });
            this.classList.add('is-active');
            resultsContainer.querySelectorAll('[data-lpl-group]').forEach(function (g) {
              g.style.display = (activeCategory === 'all' || g.dataset.lplGroup === activeCategory) ? '' : 'none';
            });
          });
        });
      }
    }

    function updateResultsHeading(count) {
      if (!resultsHeading) return;
      if (resultsCount) resultsCount.textContent = '(' + count + ' produkter)';
      resultsHeading.classList.add('is-visible');
    }

    function showNoResults() { if (noResults) noResults.classList.add('is-visible'); }

    function showError(msg) {
      if (!errorBox) return;
      errorBox.textContent = msg;
      errorBox.classList.add('is-visible');
    }

    function resetResults() {
      activeCategory = 'all';
      if (vehicleInfo) vehicleInfo.classList.remove('is-visible');
      if (errorBox) errorBox.classList.remove('is-visible');
      if (resultsHeading) resultsHeading.classList.remove('is-visible');
      if (categoryNav) { categoryNav.classList.remove('is-visible'); categoryNav.innerHTML = ''; }
      if (noResults) noResults.classList.remove('is-visible');
      if (resultsContainer) resultsContainer.innerHTML = '';
    }

    function setLoading(loading) {
      if (!submitBtn) return;
      submitBtn.classList.toggle('is-loading', loading);
      submitBtn.disabled = loading;
    }

    if (form) form.addEventListener('submit', onSubmit);
    if (input) input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); onSubmit(e); }
    });

    ensureProductIndex();
  }

  function init() {
    document.querySelectorAll('[data-lpl-section]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
